/* eslint-disable @khan/frontend/require-stories -- this file doesn't export a component */
import * as React from "react";

// This context is used in <NavLink /> to determine its hierarchy level.
//
// NOTE(mdr): We could've gone a bit more thorough with this abstraction:
//     created a general concept of "nav level", and set it in <NavSection />.
//     We could even use that strategy to merge <NavSection /> and
//     <NavSubsection /> into a single component, and determine styles entirely
//     based on the level in the nav tree. But idk, that seemed like a bit too
//     much abstraction when all we really needed was a single change in nav
//     link styles :/ Consider revisiting if our hierarchy needs become more
//     complex!
// @ts-expect-error - TS2322 - Type 'Context<{ isInSubsection: false; }>' is not assignable to type 'Context<{ isInSubsection: boolean; }>'.
export const NavSubsectionContext: React.Context<{
    isInSubsection: boolean;
}> = React.createContext({
    isInSubsection: false,
});
NavSubsectionContext.displayName = "NavSubsectionContext";
